module.exports = __webpack_public_path__ + "img/voltage.9f2d4bd7.svg";